<div *ngIf="isShowErrorMessage()" class="control-message text-danger">{{ errorMessage }}</div>
